import { CategoryService } from "../services/category.service";
import { Image } from "./image";

export class Category {
  category: Category;
  public id: number;

  public lft: Category;
  public rgt: Category;

  public parent_id: number;
  public state: number;
  public visible: boolean;

  public title: string;
  public subtitle: string;
  public description: string;

  public created: Date;
  public modified: Date;

  public parent: Category;

  children?: Category[];
  imgs?: Image[];
  featuredImg?: Image;
}
